import { useState } from "react";
import { Card, Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import BasicTable from "ui-components/tables/BasicTable";
import { ListLayout } from "ui-components/Layout";
import { Error } from "ui-components/Alert";
import { getStockHoldList } from "services/data.internal.service";
import { useCustomerValue } from "providers/CustomerContext";
import StockHoldDrawer from "./components/StockHoldDrawer";
import { TableCard } from "ui-components/Layout";
import { EditButton } from "ui-components/IconButton";
import { useTeamValue } from "providers/TeamContext";

function StockHoldList() {
  const {permissions, allowAll} = useTeamValue();
  const {customerCode} = useCustomerValue();
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [data, setData] = useState([]);
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const addPermission = allowAll || (Boolean(permissions["Stock Hold"]) && permissions["Stock Hold"].findIndex(b => b==="new") !== -1);
  const editPermission = allowAll || (Boolean(permissions["Stock Hold"]) && permissions["Stock Hold"].findIndex(b => b==="edit") !== -1);
  
  useQuery({
    queryKey: ["stock-hold-list", customerCode],
    queryFn: () => getStockHoldList({customerCode}),
    onSuccess: (data) => {
      setData(data.data.data);
    },
    onError,
  });

  const onNew = () => navigate("/inventory/stock-hold/add");

  const onEdit = (req) => {
    navigate("/inventory/stock-hold/unhold", {
      state: req,
    });
  };

  const [sHoldRequest, setSHoldRequest] = useState(null);
  const [open, setOpen] = useState(false);
  const drawerProp = {open, setOpen, sHoldRequest, setSHoldRequest}
  const columns = [
    {
      header: "Stock Hold No",
      accessorKey: "stockHoldNo",
      cell: ({ row }) => {
        const { stockHoldNo } = row.original;
        return (
          <span
            style={{ color: "#1A73E8", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => {
              setOpen(true);
              setSHoldRequest({ stockHoldNo, customerCode });
            }}
          >
            {stockHoldNo}
          </span>
        );
      },
    },
    { header: "Warehouse Code", accessorKey: "warehouseCode" },
    { header: "Created Date", accessorKey: "createdOn"},
    { header: "Created By", accessorKey: "createdBy" },
    {
      header: "Action",
      accessorKey:"action",
      enableColumnFilter: false,
      cell: ({ row }) => {
        const { stockHoldNo, status } = row.original;
        return status === "O" ? (
          <>
            <EditButton
              title="edit stock hold"
              disabled={!editPermission}
              onClick={() => {
                onEdit({ stockHoldNo, customerCode });
              }}
            />
          </>
        ) : (
          <></>
        );
      },
    }
  ];

  return (
    <ListLayout>
      <StockHoldDrawer {...drawerProp} />
      {alert}
      {dialog}
      <TableCard sx={{my:3}}>
        <MDBox display="flex" justifyContent="space-between" margin="10px">
        <MDButton variant="gradient" color="info" disabled={!addPermission} onClick={onNew}>
            <Icon>add</Icon>&nbsp;stock&nbsp;hold
          </MDButton>
        </MDBox>
        <BasicTable columns={columns} data={data} />
      </TableCard>
    </ListLayout>
  );
}

export default StockHoldList;
